import { Message } from '@dinosband/bv-messenger-schema'
import { User_ChatRoomView } from '@dinosband/bv-main-schema/dist/types'

import { SubscriptionManager } from '@dinosband/bv-data-center'
import { MESSAGE_ADDED, MESSAGE_UPDATED, MESSAGE_DELETED, USER_CHAT_ROOM_VIEW_UPDATED } from '@dinosband/bv-data-center'

import { ChatRoomStore } from './chat-room-store'
import { MessengerContext, MessengerVuex } from '..'
import { isPrivateChatRoom } from '@dinosband/bv-main-schema/dist/chat-room'

export class ChatRoomStorePool {

  context: MessengerContext
  vuexStore: MessengerVuex

  private _pool: Record<number, ChatRoomStore> = {}
  private subscriptions = new SubscriptionManager()

  constructor (context: MessengerContext) {
    this.context = context
    this.vuexStore = context.vuexStore
    this.initSubscribe()
  }

  prepare () {
    // mainStore가 설정되고 나서 실행되어야 하므로 constructor 에서 부르지 못한다
    const mainStore = this.context.mainStore
    mainStore.watch.subscribe(mainStore.USER_CHANGED, () => {
      this.userDidChange()
    })
  }

  cleanup () {
    // this.subscriptions.cleanup()
    Object.values(this._pool).forEach((store) => store.cleanup())
    this._pool = {}
  }

  store (chatRoomId: number) {
    let store = this._pool[chatRoomId]
    if (!store) {
      const dataCenter = this.context.dataCenter
      store = new ChatRoomStore(chatRoomId, this.vuexStore, this.context.pubsub)
      store.userView = dataCenter.userViews.get(chatRoomId)
      this._pool[chatRoomId] = store
    }
    return store
  }

  deinitStore (chatRoomId: number) {
    const store = this._pool[chatRoomId]
    if (store) {
      store.cleanup()
      delete this._pool[chatRoomId]
    }
  }

  private initSubscribe () {
    // will be called when ./controller-pool.ts
    // pubsub.subscribe(CHAT_ROOM_ADDED, async (info: ChatRoomAddedPayload) => {
    //   this.initChatRooms(info.chatRooms)
    // })
    this.subscriptions.init(this.context.pubsub)
    this.subscriptions.subscribe(MESSAGE_ADDED, (message: Message) => {
      this.store(message.chatRoomId).addMessage(message)
      const commentsRootChatRoomId = message.props.commentsRootChatRoomId
      if (commentsRootChatRoomId) {
        this.store(commentsRootChatRoomId).addCommentsChatRoomInfos([message])
      }
    })
    this.subscriptions.subscribe(MESSAGE_UPDATED, (payload: { message: Message, valid: boolean}) => {
      const { message, valid } = payload
      this.store(message.chatRoomId).updateMessage(message, valid)
    })
    this.subscriptions.subscribe(MESSAGE_DELETED, (message: Message) => {
      this.store(message.chatRoomId).removeMessage(message)
    })
    this.subscriptions.subscribe(USER_CHAT_ROOM_VIEW_UPDATED, (userView: User_ChatRoomView) => {
      this.store(userView.chatRoomId).userView = userView
    })
    // will be called by chat-room-data-subscriber
    // this.subscriptions.subscribe(JOB_OFFER_RESPONSE_UPDATED, (jrsp: JobOfferResponse) => {
    //   this.store(jrsp.chatRoomId).jobOfferResponse = jrsp
    // })
  }

  // private async initChatRooms (chatRooms: ChatRoom[]) {
  //   chatRooms.forEach((i) => { this.initStore(i) })
  // }

  private userDidChange () {
    const profiles = this.context.mainStore.profiles
    if (!profiles.length) {
      return
    }
    const targets = Object.values(this._pool)
      .filter((i) => isPrivateChatRoom(i.state?.chatRoom?.type))
      .filter((i) => !i.userProfile)
    targets.forEach((i) => i.updateUserProfile(profiles))
  }

}